import { preloadImages } from './utils';
import Slideshow from './slideshow';

// Preload  images and fonts
Promise.all([preloadImages('.content__slide-item', { background: true })]).then(() => {
    // Initialize stuff
    new Slideshow(document.querySelectorAll('.content__slide'));
});

